import React, {Component} from 'react';
import {connect} from 'react-redux';
import Modal from 'react-modal';
import PropTypes from 'prop-types';

import '../components/stylefeedback.css';

import {cancelAction as cancelActionRedux} from '../services/confirmAction/action';
import {addNotification} from "../services/notification/action";
import Translate, {t} from "./Translate";
import {endConversationRequested, selectConversationRequested} from "../services/chat/action";
import ShowChatIcon from "../assets/ShowChatIcon";
import PlatformIcon from "../components-new/PlatformIcon";
import config from "../config";
import ChatMoreInfoModal from "./ChatMoreInfoModal";
import {filterInputStyle, myDarkBlue} from "../utils/General";
import ExcelButton from "../components-new/buttons/ExcelButton";
import {generateModalDataExcel, getModalData} from "../services/statistics/api";
import TablePagination from "./TablePagination";
import LoadingComponent from "../assets/LoadingComponent";
import TableHeaderSort from "../components-new/Table/TableHeaderSort";
import ResetButton from "../components-new/buttons/ResetButton";

const style = {
    overlay: {
        backgroundColor: config.modalBackgroundColor,
        zIndex: '2000',
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        borderRadius: '20px',
        transform: 'translate(-50%, -50%)',
        padding: '40px',
        border: 'none',
        minWidth: '85%',
        maxWidth: '90%',
        height: '80%'
    },
    title: {
        color: 'black',
        marginBottom: '20px',
        textAlign: 'center',
    },
};

const styles = {
    parentTableDiv: {
        flex: 1,
        overflow: 'auto',
        marginBottom: '10px',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        borderRadius: '20px',
        overflow: 'visible',
        tableLayout: 'fixed',
    },
    th: {
        padding: '12px 15px',
        backgroundColor: myDarkBlue,
        color: 'white',
        textAlign: 'left',
        cursor: 'pointer',
        width: '12.5%', // 8 columns equally divided
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    td: {
        border: '0',
        padding: '12px 15px',
        textAlign: 'left',
        color: myDarkBlue,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    userCell: {
        fontWeight: 'bold',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
    },
    userSubCell: {
        fontSize: '10px',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
    }
};


Modal.setAppElement('#root');

class StatisticsConvModal extends Component {
    constructor(props) {
        super(props);

        this.subCompanies = (props.company && props.company.subs) ? props.company.subs : [];

        this.state = {
            isInnerModalOpen: false,
            selectedChat: null,
            filteredConversations: [],
            scrollTop: 0,
            pageable: {
                page: 0,
                size: 10,
                sort: 'createdAt,desc'
            },
            totalElements: 0,
            totalPages: 0,
            filters: {
                type: props.header,
                companyIds: this.subCompanies.map(sub => sub.id),
                chatId: '',
                operator: '',
                operatorId: null,
                user: '',
                platforms: '',
                bot: '',
                statuses: '',
                forwarded: null,
                unanswered: null,
                start: '',
                end: ''
            },
            conversations: [],
            blockedFilters: {},
            isFetching: false,
            isFetchingExcel: false
        };
        this.fetchTimeout = null;
        this.headers = [
            {translateKey: 'id', sortColumn: 'conversation.id'},
            {translateKey: 'company', sortColumn: 'companyInfo.companyName'},
            {translateKey: 'platform', sortColumn: 'platform'},
            {translateKey: 'Status', sortColumn: 'status'},
            {translateKey: 'user', sortColumn: 'user.firstName,user.lastName'},
            {translateKey: 'operator', sortColumn: 'operator.firstName,operator.lastName'},
            {translateKey: 'createdAt', sortColumn: 'createdAt'},
            {translateKey: 'actions'},
        ]

        this.initialFiltersState = {
            ...this.state.filters,
            ...this.props.filters
        }
    }

    componentDidMount() {
        this.setState({
            filters: {
                ...this.initialFiltersState,
            },
        }, this.fetchData)

        this.setState({
            blockedFilters: {
                platforms: !!this.props.filters.platforms,
                bot: !!this.props.filters.bot,
                operator: !!this.props.filters.operator
            }
        })
    }

    updateFilter(key, value, debounced = false) {
        this.setState({
                filters: {
                    ...this.state.filters,
                    [key]: value
                },
                pageable: {
                    ...this.state.pageable,
                    page: 0
                }
            },
            () => {
                if (!debounced) {
                    this.fetchData();
                    return;
                }
                clearTimeout(this.fetchTimeout);
                this.fetchTimeout = setTimeout(() => {
                    this.fetchData();
                }, 300)

            })
    }

    updatePageable(key, value) {
        this.setState({
                pageable: {
                    ...this.state.pageable,
                    [key]: value
                }
            },
            this.fetchData
        )
    }

    handleSort(column) {
        if (!column) return

        const sort = this.state.pageable.sort;
        let newSort
        let currentColumn, currentOrder

        if (sort) {
            currentOrder = sort.split(',').pop();
            currentColumn = sort.split(',').slice(0, -1).join(',');
        }

        if (currentOrder && currentColumn === column) {
            newSort = column + ',' + (currentOrder === 'asc' ? 'desc' : 'asc');
        } else {
            newSort = column + ',' + 'asc'
        }

        this.setState({
                pageable: {
                    ...this.state.pageable,
                    sort: newSort,
                }
            },
            this.fetchData
        )
    }

    resetFilters() {
        this.setState({
            filters: {
                ...this.initialFiltersState,
            }
        }, this.fetchData)
    }

    isResetFiltersActive() {
        return Object.entries(this.initialFiltersState)
            .some(([key, value]) => value !== this.state.filters[key])
    }

    fetchData() {
        this.setState({
            isFetching: true
        })

        getModalData(this.state.filters, this.state.pageable).then(result => {
            if (result && result.content && result.pageable) {
                this.setState({
                    conversations: result.content,
                    pageable: {
                        page: result.pageable.pageNumber,
                        size: result.pageable.pageSize,
                        sort: this.state.pageable.sort
                    },
                    totalElements: result.totalElements,
                    totalPages: result.totalPages === 0 ? 1 : result.totalPages,
                })
            } else {
                this.setState({
                    conversations: [],
                    totalPages: 1,
                    totalElements: 0
                })
            }
        }).catch(e => {
            this.setState({
                conversations: [],
                totalPages: 1,
                totalElements: 0
            })
        }).finally(() => {
            this.setState({
                isFetching: false
            })
        });
    }

    closeModal = () => {
        this.props.cancelAction();
    };

    openTrModal = (conversation) => {
        this.setState({
            selectedChat: conversation,
            isInnerModalOpen: true,
        });
    };

    closeInnerModal = () => {
        this.setState({
            selectedChat: null,
            isInnerModalOpen: false,
        });
    };

    onScroll = (e) => {
        this.setState({scrollTop: e.target.scrollTop});
    };

    handleExport = () => {
        const {header} = this.props;
        this.setState({ isFetchingExcel:true })
        generateModalDataExcel(header, this.state.filters).finally(() => {
            this.setState({ isFetchingExcel: false });
        })
    };

    renderRow = (conversationDetails) => {
        const {showConversationHistory, header} = this.props;
        const {showFullConversationHistory} = this.props;

        return (
            <tr
                key={conversationDetails.conversationId + conversationDetails.createdAt}
                className={'clickable-row'}
                onClick={(e) => {
                    if (e.target.closest('.chat-action')) return;
                    this.openTrModal(conversationDetails)
                }}
            >
                <td style={styles.td}>{conversationDetails.conversationId}</td>
                <td style={styles.td}>{conversationDetails.botName}</td>
                <td style={styles.td}>
                    <PlatformIcon platform={conversationDetails.platform} size={30}/>
                </td>
                <td style={{...styles.td, whiteSpace: 'none'}}>
                    <Translate text={conversationDetails.status}/>
                </td>
                <td style={{...styles.td, display: 'flex', flexDirection: 'column'}}>
                    <div style={styles.userCell}>
                        {conversationDetails.customerName}
                    </div>
                    <div style={styles.userSubCell}>{conversationDetails.visitorEmail}</div>
                    <div style={styles.userSubCell}>{conversationDetails.visitorPhoneNumber}</div>
                </td>
                <td style={{...styles.td, fontWeight: 'bold'}}>{conversationDetails.operatorFullName}</td>
                <td style={styles.td}>{new Date(conversationDetails.createdAt).toLocaleString('en-GB') || 'N/A'}</td>
                <td style={{...styles.td}}>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '30px'}}>
                        <span
                            className="chat-action"
                            style={{marginTop: '3px', cursor: 'pointer'}}
                            onClick={(e) => {
                                if (header !== 'activeRequests') {
                                    showConversationHistory(conversationDetails);
                                } else {
                                    showFullConversationHistory(conversationDetails);
                                }
                            }}
                        >
                           <ShowChatIcon style={{height: '21px', width: '21px'}}/>
                       </span>
                        {header !== 'activeRequests' && (
                            <span
                                className="chat-action"
                                style={{marginTop: '3px', cursor: 'pointer'}}
                                onClick={(e) => {
                                    showFullConversationHistory(conversationDetails);
                                }}
                            >
                               <ShowChatIcon fill={'rgba(255,0,0,0.58)'} text={'fullChatHistory'}
                                             style={{height: '21px', width: '21px'}}/>
                           </span>
                        )}
                    </div>
                </td>
            </tr>
        );
    };

    render() {
        const {isOpen, header, user} = this.props;
        const {
            isInnerModalOpen,
            selectedChat,
            pageable,
            totalPages,
            totalElements,
            conversations,
            isFetching,
            isFetchingExcel,
            filters,
            blockedFilters
        } = this.state;

        return (
            <React.Fragment>
                <Modal closeTimeoutMS={config.closeTimeoutMS}
                       isOpen={isOpen}
                       style={style}
                       onRequestClose={this.closeModal}>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        maxHeight: '100vh',
                    }}
                    >

                        <h2 style={{
                            ...style.title,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px'
                        }}>
                            <Translate text={header}/> ({totalElements})
                        </h2>

                        <div
                            style={{
                                marginBottom: '20px',
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '20px',
                                justifyContent: 'space-between',
                            }}
                        >
                            <input
                                type="text"
                                placeholder={t({text: 'searchByConversationID', user})}
                                value={filters.chatId}
                                onChange={(e) => this.updateFilter('chatId', e.target.value, true)}
                                style={filterInputStyle}
                            />

                            <input
                                type="text"
                                placeholder={t({text: 'searchByOperator', user})}
                                defaultValue={filters.operator}
                                onChange={(e) => this.updateFilter('operator', e.target.value, true)}
                                style={filterInputStyle}
                                disabled={blockedFilters.operator}
                            />

                            <input
                                type="text"
                                placeholder={t({text: 'searchByUser', user})}
                                value={filters.user}
                                onChange={(e) => this.updateFilter('user', e.target.value, true)}
                                style={filterInputStyle}
                            />

                            <select
                                value={filters.platforms}
                                onChange={(e) => this.updateFilter('platforms', e.target.value)}
                                style={filterInputStyle}
                                disabled={blockedFilters.platforms}
                            >
                                <option value="">{t({text: 'allPlatforms', user})}</option>
                                {Object.entries(config.platformsMap)
                                    .filter(([key]) => key !== 'company')
                                    .map(([key, label]) => (
                                        <option key={key} value={label}>
                                            {label}
                                        </option>
                                    ))}
                            </select>

                            <select
                                value={filters.bot}
                                onChange={(e) => this.updateFilter('bot', e.target.value)}
                                style={filterInputStyle}
                                disabled={blockedFilters.bot}
                            >
                                <option value="">{t({text: 'allBots', user})}</option>
                                {this.subCompanies.map((bot) => (
                                    <option key={bot.id} value={bot.id}>{bot.name}</option>
                                ))}
                            </select>


                            <select
                                value={filters.statuses}
                                onChange={(e) => this.updateFilter('statuses', e.target.value)}
                                style={filterInputStyle}
                                disabled={filters.type === 'activeRequests'}
                            >
                                <option value="">{t({text: 'allStatuses', user})}</option>
                                {config.conversationStatusesList.map((status) => (
                                    <option key={status} value={status}>
                                        {t({text: status, user})}
                                    </option>
                                ))}
                            </select>


                            <input
                                type="date"
                                value={filters.start}
                                onChange={(e) => this.updateFilter('start', e.target.value)}
                                style={filterInputStyle}
                            />

                            <input
                                type="date"
                                value={filters.end}
                                onChange={(e) => this.updateFilter('end', e.target.value)}
                                style={filterInputStyle}
                            />


                        </div>

                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '20px'
                        }}>
                            <div>
                                <ResetButton
                                    onClick={() => this.resetFilters()}
                                    width={200}
                                    height={40}
                                    variant='outline'
                                    disabled={!this.isResetFiltersActive()}
                                />
                            </div>
                            <div>
                                <ExcelButton
                                    onClick={this.handleExport}
                                    width={200}
                                    height={40}
                                    variant={'outline'}
                                    loading={isFetchingExcel}
                                    children={
                                        <span style={{fontSize: '14px', backgroundColor: 'transparent'}}>
                                        <Translate text={'downloadXls'}/>
                                    </span>
                                    }
                                />
                            </div>
                        </div>

                        <div style={styles.parentTableDiv} onScroll={this.onScroll}>
                            <table className={'custom-table'} style={styles.table}>
                                <thead>
                                <tr>
                                    {this.headers.map((header, index) => (
                                        <th
                                            key={header.translateKey}
                                            style={styles.th}
                                            onClick={() => this.handleSort(header.sortColumn)}
                                        >
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                                justifyContent: index === this.headers.length - 1 ? 'center' : 'start',
                                            }}>
                                                <Translate text={header.translateKey}/>
                                                {
                                                    header.sortColumn
                                                    &&
                                                    <TableHeaderSort
                                                        isActive={pageable.sort.split(',').slice(0, -1).join(',') === header.sortColumn}
                                                        direction={pageable.sort.split(',').pop()}
                                                    />
                                                }

                                            </div>
                                        </th>
                                    ))}
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    !isFetching && conversations.map(this.renderRow)
                                }
                                {
                                    conversations.length === 0 && !isFetching &&
                                    <tr>
                                        <td colSpan="100%"
                                            style={{textAlign: 'center', padding: '40px', color: '#6c757d'}}>
                                            <Translate text={'noResultsFound'}/>
                                        </td>
                                    </tr>
                                }
                                </tbody>
                            </table>
                            {
                                isFetching
                                &&
                                <div style={{height: '150px'}}>
                                    <LoadingComponent/>
                                </div>
                            }
                        </div>

                        <div style={{
                            display: 'flex',
                            flexShrink: 0,
                            padding: '10px 0',
                            backgroundColor: '#fff',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                        }}>
                            <TablePagination
                                totalRows={totalElements}
                                numberOfPages={totalPages}
                                handleChangeRowsPerPage={(size) => this.updatePageable('size', size)}
                                rowsPerPage={pageable.size}
                                curPage={pageable.page}
                                selectPage={(page) => this.updatePageable('page', page)}
                            />
                        </div>

                    </div>

                </Modal>

                {isInnerModalOpen && selectedChat && (
                    <ChatMoreInfoModal
                        fromStatistics={true}
                        isOpen={true}
                        onRequestClose={this.closeInnerModal}
                        company={this.props.company}
                        showConversationHistory={this.props.showConversationHistory}
                        conversation={selectedChat}
                    />
                )}

            </React.Fragment>
        );
    }
}

StatisticsConvModal.propTypes = {
    cancelAction: PropTypes.func,
    company: PropTypes.object,
    header: PropTypes.string,
    showConversationHistory: PropTypes.func,
    filters: PropTypes.object,
};

const mapStateToProps = (state) => ({
    isOpen: state.confirmAction.isModalOpen,
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    addNotification: () => dispatch(addNotification()),
    selectConversation: (conversation) => dispatch(selectConversationRequested(conversation)),
    cancelAction: () => dispatch(cancelActionRedux()),
    endConversation: () => dispatch(endConversationRequested()),
});

export default connect(mapStateToProps, mapDispatchToProps)(StatisticsConvModal);



// WEBPACK FOOTER //
// ./src/components/StatisticsConvModal.jsx